<template>
  <div class="header row row-custom">
    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-6 no-padding logo-header">
      <img src="../../static/img/logoRiva.png"/>
    </div>
    <el-dropdown class="pointer offset-xl-11 col-xl-10 offset-lg-10 col-lg-10 offset-md-6 col-md-12 offset-sm-4 col-sm-13 col-15 no-padding"
      trigger="click">
      <span class="el-dropdown-link">
        <div class="row row-custom no-padding">
          <div class="utente col-22 row row-custom no-padding">
            <div class="user-top col-24">{{ username + ' - ' + form.nome + ' ' + form.cognome }}</div>
            <div class="user-bottom col-24">
              {{ codForn }}
              {{ (codForn !== '' && ragSoc !== '') ? ' - ' : '' }}
              {{  ragSoc }}
              <span class="admin">
                {{ (this.areaAdmin !== '' && this.countryAdmin !== '' && this.codFornAdmin[this.areaAdmin][this.countryAdmin] !== '')
                        ? (' [' +
                        ((this.areaAdmin === 'TRAACQ') ? (this.codFornAdmin[this.areaAdmin][this.countryAdmin].substring(1)) : (this.codFornAdmin[this.areaAdmin][this.countryAdmin]))
                        + ']')
                        : ''
                }}
              </span>
            </div>
          </div>
          <div class="col-2 no-padding">
            <icon class="header-margin-top" name="riv-anonymous" scale="1.5" v-if="ifAmministrazione" style="color: red"></icon>
            <icon class="header-margin-top" name="riv-user3" scale="1.5" v-else></icon>
          </div>
        </div>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="goToAmministrazione" v-if="(amministrazione.length > 0)">{{ $t('header.amministrazione') }}</el-dropdown-item>
        <el-dropdown-item @click.native="goToChangeUserData">{{ $t('header.datiProfilo') }}</el-dropdown-item>
        <el-dropdown-item @click.native="goToUtenti">{{ $t('header.gestioneUtenti') }}</el-dropdown-item>
        <!--
        <el-dropdown-item @click.native="logout">Logout</el-dropdown-item>
        -->
      </el-dropdown-menu>
    </el-dropdown>

    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-3 col-3 show-messaggi">
      <el-badge :value="counterBacheca" class="item badge-bacheca" :hidden="counterBacheca === 0">
        <el-badge :value="counterNuovi" class="item badge-nuovi" :hidden="counterNuovi === 0">
          <icon class="header-margin-top pointer" name="riv-messaggi" scale="1.5" @click.native="showMessages"></icon>
        </el-badge>
      </el-badge>
    </div>

    <el-dialog class="modalProfilo" :title="$t('header.datiProfilo').toUpperCase()"
               :visible.sync="changeUserDataVisible"
               :append-to-body="true"
               custom-class="custom-dialog col-lg-offset-6 col-lg-12 col-md-offset-4 col-md-16 col-sm-offset-2 col-sm-20 col-xs-offset-1 col-xs-22">

      <el-tabs type="card" class="custom-tabs">
        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('header.infoUtente') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
          <div class="form-profilo col-24">
            <div class="row row-custom modifica">
              <div class="profilo-label">
                {{ $t('header.modifica') }}
              </div>
              <el-switch
                v-model="switchModifica"
                active-color="#007c74"
                inactive-color="#cecece">>
              </el-switch>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.ragSoc') }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input" placeholder="" v-model="form.ragSoc" clearable :disabled="true"></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.pIva') }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input" placeholder="" v-model="form.pIva" clearable :disabled="true"></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.nome') + ' (*)' }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input"
                  :class="{'error' : errorActive && form.nome === ''}"
                  placeholder="" v-model="form.nome" clearable :disabled="!switchModifica"
                ></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.cognome') + ' (*)' }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input"
                  :class="{'error' : errorActive && form.cognome === ''}"
                  placeholder="" v-model="form.cognome" clearable :disabled="!switchModifica"
                ></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.telefono') + ' (*)' }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input"
                  :class="{'error' : errorActive && form.telefono === ''}"
                  placeholder="" v-model="form.telefono" clearable :disabled="!switchModifica"
                ></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.mobile') }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input" placeholder="" v-model="form.mobile" clearable :disabled="!switchModifica"></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.mail') + ' (*)' }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input"
                  :class="{'error' : errorActive && form.mail === ''}"
                  placeholder="" v-model="form.mail" clearable :disabled="!switchModifica"
                ></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.birthday') }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-date-picker class="dt-picker-profilo custom-date-picker"
                                v-model="form.birthday" format="dd/MM/yyyy" value-format="dd/MM/yyyy"
                                type="date" :disabled="!switchModifica"
                                placeholder="">
                </el-date-picker>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.reparto') }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-input class="custom-input" placeholder="" v-model="form.reparto" clearable :disabled="!switchModifica"></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.mansione') }}
              </div>
              <div class="profilo-value col-18  no-padding">
                <el-input class="custom-input" placeholder="" v-model="form.mansione" clearable :disabled="!switchModifica"></el-input>
              </div>
            </div>
            <div class="row row-custom">
              <div class="profilo-label col-6 no-padding">
                {{ $t('header.linguaPreferita') + ' (*)' }}
              </div>
              <div class="profilo-value col-18 no-padding">
                <el-select v-model="form.preferredLanguage" :disabled="!switchModifica"
                  class="custom-select-el"
                  :class="{'error' : errorActive && form.preferredLanguage === ''}"
                >
                  <el-option
                    v-for="item in lingue"
                    :key="item.codLang"
                    :label="$t('header')[item.codLang]"
                    :value="item.codLang">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="footer col-24">
            <el-button type="primary" class="custom-button" @click="changeUserData" :disabled="!switchModifica">
              {{ $t('header.salva').toUpperCase() }}
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('header.abilitazioni') }}
            </div>
            <div class="col-xs-24 no-padding barra"></div>
          </div>
          <el-transfer
            class="col-24"
            :titles="[$t('header.richiedibili'), $t('header.richieste')]"
            v-model="appsRichieste"
            :data="appsRichiedibili">
          </el-transfer>
          <div class="footer col-24">
            <el-button type="primary" class="custom-button" @click="changeUserData">
              {{ $t('header.salva').toUpperCase() }}
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">
            <div class="col-24 no-padding">
              {{ $t('header.sicurezza') }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
          <div class="row row-custom psw-elemento text" v-if="ifMailValdiate === 'Y'">
            {{ $t('header.impostaNuovaPwd') }}
          </div>
          <div class="footer col-24" style="margin-bottom: 70px" v-if="ifMailValdiate === 'Y'">
            <el-button type="primary" class="custom-button" @click="aggiornaPsw">
              {{ $t('header.invia').toUpperCase() }}
            </el-button>
          </div>

          <div class="row row-custom psw-elemento col-24 no-padding">
            <div class="psw-label col-10">
              {{ $t('header.nuovaDomandaSicurezza') }}
            </div>
            <div class="psw-value col-14">
              <el-select v-model="formPsw.domandaSicurezza" class="col-24 no-padding custom-select-el" placeholder="">
                <el-option v-for="item in domande"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row row-custom psw-elemento">
            <div class="psw-label col-10">
              {{ $t('header.rispostaSicurezza') }}
            </div>
            <div class="psw-value col-14">
              <el-input class="custom-input" v-model="formPsw.rispostaSicurezza"></el-input>
            </div>
          </div>
          <div class="footer col-24">
            <el-button type="primary" class="custom-button"
                       @click="aggiornaDomandaSicurezza"
                       :disabled="(formPsw.domandaSicurezza === '' || formPsw.domandaSicurezza === null || formPsw.rispostaSicurezza.length === 0)">
              {{ $t('header.aggiornaDomandaSicurezza').toUpperCase() }}
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog class="modalAmministrazione" :title="$t('header.amministrazione').toUpperCase()" @close="closeAmministrazione"
               :visible.sync="ifAmministrazioneVisible" :append-to-body="true" :close-on-click-modal="false"
               custom-class="custom-dialog offset-xl-6 col-xl-12 offset-lg-5 col-lg-14 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">

      <div>
        <el-table class="custom-table"
          :data="amministrazione"
          style="width: 100%">
          <el-table-column
            label="Area"
            min-width="25">
            <template slot-scope="scope">
              {{ $t('header')[scope.row.area].toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column v-for="country in ['1', '2', '3', '4', '5']" :key="country"
            :label="$t('header.stati')[country]"
            min-width="15">
            <template slot-scope="scope">
              <div v-if="(scope.row.area !== 'TRAACQ')">
                <el-input class="custom-input" v-model="codFornAdmin[scope.row.area][country]" v-if="(scope.row.countries.indexOf(country) >= 0)"></el-input>
              </div>
              <div v-else>
                <el-select class="custom-select-el" v-model="codFornAdmin[scope.row.area][country]" v-if="(scope.row.countries.indexOf(country) >= 0)"
                    placeholder="" :filterable="true" :remote="true" :reserve-keyword="true"
                    :remote-method="((query) => searchFornAdm(country, query))" value-key="codForn"
                >
                  <el-option v-for="option in TRAACQ[country]"
                            :label="option.codForn"
                            :key="option.codForn"
                            :value="(option.tipForn + option.codForn)">
                    {{ (option.codForn + ' - ' + option.descForn) }}
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button @click="setCodForn(true)" class="custom-button">{{ $t('header.disabilita').toUpperCase() }}</el-button>
          <el-button @click="setCodForn(false)" class="custom-button" type="primary">{{ $t('header.abilita').toUpperCase() }}</el-button>
        </div>
      </span>

    </el-dialog>

    <el-dialog class="modalUtenti" :title="$t('header.gestioneUtenti').toUpperCase()"
               :visible.sync="ifUtentiVisible" :append-to-body="true"
               custom-class="custom-dialog offset-xl-4 col-xl-16 offset-lg-2 col-lg-20 offset-md-1 col-md-22 offset-sm-0 col-sm-24 offset-0 col-24">
      <div>
        <el-table class="custom-table" height="380"
          v-loading="loadingUtenti"
          :data="utenti">
          <el-table-column
            width="40">
            <template slot-scope="scope">
              <el-switch
                @change="setUtente(scope.row, scope.$index)"
                :disabled="(scope.row.codStatoUtente !== 'RDY')"
                :key="scope.row.username"
                v-model="scope.row.codStatoUtente"
                active-value="RDY"
                active-color="#ccc"
                inactive-color="red">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('header.utente')"
            prop="username"
            min-width="75">
          </el-table-column>
          <el-table-column
            :label="$t('header.cognomeNome')"
            min-width="90">
            <template slot-scope="scope">
              {{ scope.row.cognome + ' ' + scope.row.nome }}
            </template>
          </el-table-column>
          <el-table-column
            align="center" header-align="center"
            :label="$t('header.nazione')"
            width="80">
            <template slot-scope="scope">
              {{ scope.row.country }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('header.societa')"
            min-width="110"
            prop="descSoc">
          </el-table-column>
          <el-table-column
            :label="$t('header.mail')"
            min-width="180">
            <template slot-scope="scope">
              <el-input class="custom-input" v-model="scope.row.mail" :disabled="(scope.row.ifModifica === false)"></el-input>
              <icon name="riv-pencil" class="icon-modifica pointer" scale="0.9" @click.native="(scope.row.ifModifica = true)"></icon>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button @click="salvaUtenti" class="custom-button" :disabled="loadingUtenti" type="primary">{{ $t('header.salva').toUpperCase() }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {bus} from './Bus.js'

  export default {
    name: 'Header',
    i18n: {
      messages: {
        it_IT: {
          header: {
            datiProfilo: 'Dati profilo',
            nome: 'Nome',
            cognome: 'Cognome',
            telefono: 'Telefono',
            mobile: 'Cellulare',
            mail: 'Email',
            birthday: 'Data di nascita',
            reparto: 'Reparto',
            mansione: 'Mansione',
            salva: 'Salva',
            linguaPreferita: 'Lingua preferita',
            italia: 'Italia',
            francia: 'Francia',
            spagna: 'Spagna',
            belgio: 'Belgio',
            germania: 'Germania',
            stato: 'Stato',
            ragSoc: 'Ragione Sociale',
            pIva: 'Partita IVA',
            modifica: 'Modifica',
            infoUtente: 'Dati Utente',
            abilitazioni: 'Abilitazioni',
            richiedibili: 'Servizi Disponibili',
            richieste: 'Servizi Richiesti',
            sicurezza: 'Sicurezza',
            vecchiaPsw: 'Vecchia Password',
            nuovaPsw: 'Nuova Password',
            ripetiNuovaPsw: 'Ripeti Nuova Password',
            aggiornaPsw: 'Aggiorna',
            nuovaDomandaSicurezza: 'Nuova Domanda di Sicurezza',
            rispostaSicurezza: 'Risposta',
            aggiornaDomandaSicurezza: 'Aggiorna',
            amministrazione: 'Amministrazione',
            TRAACQ: 'Rottame',
            UFFACQ: 'Area Acquisti',
            ACCSTA: 'Accesso Stabilimenti',
            abilita: 'Abilita',
            disabilita: 'Disabilita',
            stati: {
              1: 'Italia',
              2: 'Francia',
              3: 'Spagna',
              4: 'Belgio',
              5: 'Germania'
            },
            gestioneUtenti: 'Utenti Registrati',
            utente: 'Utente',
            cognomeNome: 'Cognome e Nome',
            nazione: 'Nazione',
            societa: 'Società',
            attenzione: 'Attenzione',
            bloccareUtente: 'Confermi di voler BLOCCARE l\'utente selezionato?',
            annulla: 'Annulla',
            ok: 'Ok',
            impostaNuovaPwd: 'Desideri modificare la password? Ti verrà inviata un\'email con un link per prcedere alla modifica.',
            invia: 'Invia'
          }
        },
        fr_FR: {
          header: {
            datiProfilo: 'Données de profil',
            nome: 'Prénom',
            cognome: 'Nom',
            telefono: 'Téléphone',
            mobile: 'Téléphone portable',
            mail: 'Email',
            birthday: 'Date de naissance',
            reparto: 'Département',
            mansione: 'Emploi',
            salva: 'Sauver',
            linguaPreferita: 'Langue préférée',
            italia: 'Italie',
            francia: 'France',
            spagna: 'Espagne',
            belgio: 'Belgique',
            germania: 'Allemagne',
            stato: 'Nation',
            ragSoc: 'Nom de l\'Entreprise',
            pIva: 'Numéro de TVA',
            modifica: 'Changement',
            infoUtente: 'Données Utilisateur',
            abilitazioni: 'Permettant',
            richiedibili: 'Services Disponibles',
            richieste: 'Services Demandés',
            sicurezza: 'Sécurité',
            vecchiaPsw: 'Ancien Mot de Passe',
            nuovaPsw: 'Nouveau  Mot de Passe',
            ripetiNuovaPsw: 'Répéter Nouveau Mot de Passe',
            aggiornaPsw: 'Mettre à Jour',
            nuovaDomandaSicurezza: 'Nouvelle Question de Sécurité',
            rispostaSicurezza: 'Réponse',
            aggiornaDomandaSicurezza: 'Mettre à Jour',
            amministrazione: 'Administration',
            TRAACQ: 'Ferraille',
            UFFACQ: 'Fourniture',
            ACCSTA: 'Accès à l\'établissement',
            abilita: 'Permettre',
            disabilita: 'Désactiver',
            stati: {
              1: 'Italie',
              2: 'France',
              3: 'Espagne',
              4: 'Belgique',
              5: 'Allemagne'
            },
            gestioneUtenti: 'Gestion Utilisateurs',
            utente: 'Utilisateur',
            cognomeNome: 'Nom et Prénom',
            nazione: 'Nation',
            societa: 'Société',
            attenzione: 'Avertissement',
            bloccareUtente: 'Confirmez-vous que vous souhaitez bloquer l\'utilisateur sélectionné?',
            annulla: 'Annuler',
            ok: 'Ok',
            impostaNuovaPwd: 'Souhaitez-vous modifier votre mot de passe? Un e-mail vous sera envoyé avec un lien pour procéder à la modification.',
            invia: 'Envoyer'
          }
        },
        es_ES: {
          header: {
            datiProfilo: 'Datos de perfil',
            nome: 'Nombre',
            cognome: 'Apellido',
            telefono: 'Teléfono',
            mobile: 'Teléfono móvil',
            mail: 'Mail',
            birthday: 'Hace falta',
            reparto: 'Departamento',
            mansione: 'Cargo',
            salva: 'Guardar',
            linguaPreferita: 'Idioma preferido',
            italia: 'Italia',
            francia: 'Francia',
            spagna: 'España',
            belgio: 'Bélgica',
            germania: 'Alemania',
            stato: 'País',
            ragSoc: 'Nombre Empresa',
            pIva: 'C.I.F.',
            modifica: 'Cambio',
            infoUtente: 'Datos de Usuario',
            abilitazioni: 'Permisos',
            richiedibili: 'Permisos Disponibles',
            richieste: 'Permisos Solicitados',
            sicurezza: 'Seguridad',
            vecchiaPsw: 'Contraseña Antigua',
            nuovaPsw: 'Nueva Contraseña',
            ripetiNuovaPsw: 'Repetir Nueva Contraseña',
            aggiornaPsw: 'Actualizar',
            nuovaDomandaSicurezza: 'Nueva Pregunta de Seguridad',
            rispostaSicurezza: 'Respuesta',
            aggiornaDomandaSicurezza: 'Actualizar',
            amministrazione: 'Administración',
            TRAACQ: 'Chatarra',
            UFFACQ: 'Suministro',
            ACCSTA: 'Acceso al Establecimiento',
            abilita: 'Permitir',
            disabilita: 'Desactivar',
            stati: {
              1: 'Italia',
              2: 'Francia',
              3: 'España',
              4: 'Bélgica',
              5: 'Alemania'
            },
            gestioneUtenti: 'Gestión Usuarios',
            utente: 'Usuario',
            cognomeNome: 'Apellido y Nombre',
            nazione: 'Nación',
            societa: 'Sociedad',
            attenzione: 'Precaución',
            bloccareUtente: '¿Confirmas que quieres bloquear al usuario seleccionado?',
            annulla: 'Cancelar',
            ok: 'Ok',
            impostaNuovaPwd: '¿Deseas cambiar tu contraseña? Se te enviará un correo electrónico con un enlace para proceder al cambio.',
            invia: 'Enviar'
          }
        },
        de_DE: {
          header: {
            datiProfilo: 'Profildaten',
            nome: 'Vorname',
            cognome: 'Nachname',
            telefono: 'Telefon',
            mobile: 'Mobiltelefon',
            mail: 'E-Mail',
            birthday: 'Geburtsdatum',
            reparto: 'Abteilung',
            mansione: 'Tätigkeit',
            salva: 'Speichern',
            linguaPreferita: 'bevorzugte Sprache',
            italia: 'Italien',
            francia: 'Frankreich',
            spagna: 'Spanien',
            belgio: 'Belgien',
            germania: 'Deutschland',
            stato: 'Land',
            ragSoc: 'Firmenname',
            pIva: 'Umsatzsteuernummer',
            modifica: 'Korrektur',
            infoUtente: 'Benutzerdaten',
            abilitazioni: 'Aktivieren',
            richiedibili: 'Verfügbare Dienste',
            richieste: 'Angeforderte Dienste',
            sicurezza: 'Sicherheit',
            vecchiaPsw: 'Altes Passwort',
            nuovaPsw: 'Neues Passwort',
            ripetiNuovaPsw: 'Neues Passwort wiederholen',
            aggiornaPsw: 'Aktualisieren',
            nuovaDomandaSicurezza: 'Neue Sicherheitsfrage',
            rispostaSicurezza: 'Antwort',
            aggiornaDomandaSicurezza: 'Aktualisieren',
            amministrazione: 'Verwaltung',
            TRAACQ: 'Schrott Transport',
            UFFACQ: 'Einkaufsbereich',
            ACCSTA: 'Zugang zur Einrichtung',
            abilita: 'Ermöglichen',
            disabilita: 'Deaktivieren',
            stati: {
              1: 'Italien',
              2: 'Frankreich',
              3: 'Spanien',
              4: 'Belgien',
              5: 'Deutschland'
            },
            gestioneUtenti: 'Benutzerverwaltung',
            utente: 'Benutzer',
            cognomeNome: 'Vorname und Nachname',
            nazione: 'Nation',
            societa: 'Gesellschaft',
            attenzione: 'Vorsicht',
            bloccareUtente: 'Möchten Sie den ausgewählten Benutzer wirklich blockieren?',
            annulla: 'Stornieren',
            ok: 'Ok',
            impostaNuovaPwd: 'Möchten Sie Ihr Passwort ändern? Sie erhalten eine E-Mail mit einem Link zur Änderung.',
            invia: 'Senden'
          }
        },
        en_GB: {
          header: {
            datiProfilo: 'Profile data',
            nome: 'Name',
            cognome: 'Surname',
            telefono: 'Telephone',
            mobile: 'Mobile phone',
            mail: 'Email',
            birthday: 'Date of birth',
            reparto: 'Department',
            mansione: 'Task',
            salva: 'Save',
            linguaPreferita: 'Preferred Language',
            italia: 'Italy',
            francia: 'France',
            spagna: 'Spain',
            belgio: 'Belgium',
            germania: 'Germany',
            stato: 'Country',
            ragSoc: 'Business Name',
            pIva: 'VAT Number',
            modifica: 'Change',
            infoUtente: 'User Data',
            abilitazioni: 'Enabling',
            richiedibili: 'Available Services',
            richieste: 'Requested Services',
            sicurezza: 'Safety',
            vecchiaPsw: 'Old Password',
            nuovaPsw: 'New Password',
            ripetiNuovaPsw: 'Repeat New Password',
            aggiornaPsw: 'Update',
            nuovaDomandaSicurezza: 'New Security Question',
            rispostaSicurezza: 'Answer',
            aggiornaDomandaSicurezza: 'Update',
            amministrazione: 'Administration',
            TRAACQ: 'Transport Scrap',
            UFFACQ: 'Supply',
            ACCSTA: 'Establishment access',
            abilita: 'Enable',
            disabilita: 'Disable',
            stati: {
              1: 'Italy',
              2: 'France',
              3: 'Spain',
              4: 'Belgium',
              5: 'Germany'
            },
            gestioneUtenti: 'User Management',
            utente: 'User',
            cognomeNome: 'Surname and Name',
            nazione: 'Nation',
            societa: 'Society',
            attenzione: 'Caution',
            bloccareUtente: 'Do you confirm that you want to block the selected user?',
            annulla: 'Cancel',
            ok: 'Ok',
            impostaNuovaPwd: 'Would you like to change your password? You will be sent an email with a link to proceed with the change.',
            invia: 'Send'
          }
        }
      }
    },
    props: {
      counterNuovi: {
        required: true,
        type: Number,
        default: 0
      },
      counterBacheca: {
        required: true,
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        ifUtentiVisible: false,
        utenti: [],
        loadingUtenti: false,
        errorActive: false,
        utente: '',
        codLang: '',
        username: '',
        ragSoc: '',
        codForn: '',
        changeUserDataVisible: false,
        form: {
          nome: '',
          cognome: '',
          telefono: '',
          mail: '',
          birthday: '',
          reparto: '',
          mansione: '',
          preferredLanguage: '',
          ragSoc: '',
          pIva: ''
        },
        ifMailValdiate: 'N',
        formPsw: {
          vecchiaPsw: '',
          nuovaPsw: '',
          ripetiNuovaPsw: '',
          domandaSicurezza: '',
          rispostaSicurezza: ''
        },
        domande: [],
        switchModifica: false,
        lingue: [
          {
            codLang: 'it_IT'
          },
          {
            codLang: 'fr_FR'
          },
          {
            codLang: 'es_ES'
          },
          {
            codLang: 'de_DE'
          },
          {
            codLang: 'en_GB'
          }
        ],
        appsRichieste: [],
        appsRichiedibili: [],
        amministrazione: [],
        ifAmministrazioneVisible: false,
        codFornAdmin: {
          UFFACQ: {
            1: '',
            2: '',
            3: '',
            4: '',
            5: ''
          },
          TRAACQ: {
            1: '',
            2: '',
            3: '',
            4: '',
            5: ''
          },
          ACCSTA: {
            1: '',
            2: '',
            3: '',
            4: '',
            5: ''
          }
        },
        countryAdmin: '',
        areaAdmin: '',
        ifAmministrazione: false,
        TRAACQ: {
          1: [],
          2: [],
          3: [],
          4: [],
          5: []
        },
        UFFACQ: {
          1: [],
          2: [],
          3: [],
          4: [],
          5: []
        }
      }
    },
    beforeMount: function () {
      if (sessionStorage.hasOwnProperty('codLang')) {
        this.$root.$i18n.locale = sessionStorage.getItem('codLang')
        this.codLang = sessionStorage.getItem('codLang')
      } else {
        sessionStorage.setItem('codLang', 'it_IT')
        this.$root.$i18n.locale = 'it_IT'
        this.codLang = 'it_IT'
      }
      if (localStorage.hasOwnProperty('amministrazione')) {
        this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
      }
      this.getUserData()
      this.getDomandeSicurezza()
      this.checkAmministrazione()
      bus.$on('Header_ChangeAdmin', (country, area) => {
        this.$set(this, 'countryAdmin', country)
        this.$set(this, 'areaAdmin', area)
      })

    },
    methods: {
      salvaUtenti: function () {
        let utenti = []
        this.utenti.forEach(utente => {
          if (utente.ifModifica) {
            let utenteModificato = {
              username: utente.username,
              ifBlocca: 'N',
              mail: utente.mail
            }
            utenti.push(utenteModificato)
          }
        })
        let data = {
          utenti: utenti
        }
        this.$http.post('portale/utenti', data, {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.goToUtenti()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      setUtente: function (utente, index) {
        this.$confirm(this.$t('header.bloccareUtente'), this.$t('header.attenzione').toUpperCase(), {
          confirmButtonText: this.$t('header.ok').toUpperCase(),
          cancelButtonText: this.$t('header.annulla').toUpperCase(),
          type: 'warning',
          customClass: 'custom-confirm',
          showClose: false,
          showCancelButton: true,
          closeOnClickModal: true
        })
          .then(() => {
            let utenteToBlock = {
              username: utente.username,
              ifBlocca: 'S',
              mail: ''
            }
            let utenti = [utenteToBlock]
            let data = {
              utenti: utenti
            }
            this.$http.post('portale/utenti', data, {
              params: {
                codLang: this.codLang
              }
            })
              .then(response => {
                if (response.body.rc === 0) {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                  this.goToUtenti()
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
              })
          })
          .catch(() => {
            this.$set(this.utenti[index], 'codStatoUtente', 'RDY')
          })
      },
      goToUtenti: function () {
        this.$set(this, 'utenti', [])
        this.$set(this, 'loadingUtenti', true)
        this.$set(this, 'ifUtentiVisible', true)
        this.$http.get('portale/utenti', {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              data.forEach(utente => {
                utente.ifModifica = false
              })
              this.$set(this, 'utenti', data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loadingUtenti', false)
          })
      },
      searchFornAdm: function (country, query) {
        if (query !== '') {
          this.getListFornAdm(country, query)
        } else {
          this.TRAACQ[country] = []
        }
      },
      getListFornAdm: function (country, query) {
        this.$http.get('buonidiscarico/fornitoriadm', {
          params: {
            codLang: this.codLang,
            country: country,
            filtro: query
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.TRAACQ[country] = response.body.data
            } else {
              this.TRAACQ[country] = []
              /*
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              */
            }
          })
      },
      closeAmministrazione: function () {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
        }
        let TRAACQ = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: []
        }
        let UFFACQ = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: []
        }
        this.$set(this, 'TRAACQ', TRAACQ)
        this.$set(this, 'UFFACQ', UFFACQ)
      },
      setCodForn: function (ifDisattiva) {
        sessionStorage.removeItem('SO_form')
        sessionStorage.removeItem('BdR_form')
        sessionStorage.removeItem('RdO_form')
        sessionStorage.removeItem('WGR_form')
        sessionStorage.removeItem('WGR_conf')
        sessionStorage.removeItem('WSR_form')
        this.$store.commit('reset')
        if (ifDisattiva === true) {
          let amministrazione = {
            UFFACQ: {
              1: '',
              2: '',
              3: '',
              4: '',
              5: ''
            },
            TRAACQ: {
              1: '',
              2: '',
              3: '',
              4: '',
              5: ''
            }
          }
          this.$set(this, 'codFornAdmin', amministrazione)
          this.$set(this, 'ifAmministrazione', false)
          localStorage.removeItem('amministrazione')
        } else {
          this.$set(this, 'ifAmministrazione', true)
          localStorage.setItem('amministrazione', JSON.stringify(this.codFornAdmin))
        }
        bus.$emit('Header_SetCodFornAdmin')
        this.$set(this, 'ifAmministrazioneVisible', false)
        if (this.$route.path.startsWith('/rottame')) {
          this.$router.push({ name: 'TRAACQ' })
        } else if (this.$route.path.startsWith('/fornitura')) {
          this.$router.push({ name: 'UFFACQ' })
        }
      },
      goToAmministrazione: function () {
        this.$set(this, 'ifAmministrazioneVisible', true)
      },
      checkAmministrazione: function () {
        this.$http.get('portale/amministrazione', {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'amministrazione', response.body.data)
              if (response.body.data.length > 0) {
                if (localStorage.hasOwnProperty('amministrazione')) {
                  // Elimino le aree di cui non sono amministatore (se più admin accedono allo stesso PC)
                  let newCodFornAdmin = JSON.parse(JSON.stringify(this.codFornAdmin))
                  for (let areaOld in this.codFornAdmin) {
                    if (!this.amministrazione.some(el => el.area === areaOld)) {
                      delete newCodFornAdmin[areaOld]
                    }
                  }
                  this.$set(this, 'codFornAdmin', newCodFornAdmin)

                  this.amministrazione.forEach((area) => {
                    area.countriesNotAdmin.forEach((country) => {
                      if (this.codFornAdmin[area.area][country]) {
                        this.$set(this.codFornAdmin[area.area], country, '')
                      }
                    })
                    area.countries.forEach((country) => {
                      if (!this.codFornAdmin[area.area]) {
                        let newAdmin = JSON.parse(JSON.stringify(this.codFornAdmin))
                        newAdmin[area.area] = {
                          1: '',
                          2: '',
                          3: '',
                          4: '',
                          5: ''
                        }
                        this.$set(this, 'codFornAdmin', newAdmin)
                      }
                      if (area.area === 'TRAACQ' && this.codFornAdmin[area.area][country]) {
                        this.getListFornAdm(country, this.codFornAdmin[area.area][country].substring(1))
                      }
                    })
                  })

                  localStorage.setItem('amministrazione', JSON.stringify(this.codFornAdmin))

                  this.$set(this, 'ifAmministrazione', true)
                } else {
                  this.$set(this, 'ifAmministrazione', false)
                }
              } else {
                if (localStorage.hasOwnProperty('amministrazione')) {
                  localStorage.removeItem('amministrazione')
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getDomandeSicurezza: function () {
        this.$http.get('noauth/domandesic', {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'domande', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      aggiornaDomandaSicurezza: function () {
        let obj = {
          question: this.formPsw.domandaSicurezza,
          answer: this.formPsw.rispostaSicurezza
        }
        this.$http.post('portale/updatedomandasic', obj, {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.changeUserDataVisible = false
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      aggiornaPsw: async function () {
        let obj = {
          codLang: this.codLang
        }
        try {
          let response = await this.$http.post('portale/password', obj)
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.changeUserDataVisible = false
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.msg[0].idWeb ? this.$t(e.body.msg[0].idWeb) : e.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      },
      changeUserData: function () {
        if (this.form.nome && this.form.cognome && this.form.telefono && this.form.mail && this.form.preferredLanguage) {
          let array = []
          this.appsRichieste.forEach((app) => {
            let obj = {
              codiApp: app
            }
            array.push(obj)
          })
          this.$http.post('portale/user',
            {
              name: this.form.nome,
              surname: this.form.cognome,
              mail: this.form.mail,
              preferredLanguage: this.form.preferredLanguage,
              phone: this.form.telefono,
              mobile: this.form.mobile,
              birthday: this.form.birthday,
              reparto: this.form.reparto,
              mansione: this.form.mansione,
              apps: array
            },
            {
              params: {
                codLang: this.codLang
              }
            }
          )
            .then(response => {
              if (response.body.rc === 0) {
                this.changeUserDataVisible = false
                this.getUserData()
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            })
        } else {
          this.$set(this, 'errorActive', true)
        }
      },
      goToChangeUserData: function () {
        this.switchModifica = false
        let obj = {
          vecchiaPsw: '',
          nuovaPsw: '',
          ripetiNuovaPsw: '',
          domandaSicurezza: '',
          rispostaSicurezza: ''
        }
        this.$set(this, 'formPsw', obj)
        this.$set(this, 'errorActive', false)
        this.changeUserDataVisible = true
      },
      showMessages: function () {
        this.$emit('showMessages')
      },
      getUserData: function () {
        this.$http.get('portale/utente', {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this, 'username', data.username)
              this.$set(this, 'ragSoc', data.ragSoc)
              sessionStorage.setItem('ragSocFornitore', data.ragSoc)
              this.$set(this, 'codForn', data.codForn)
              this.$set(this.form, 'nome', data.nome)
              this.$set(this.form, 'cognome', data.cognome)
              sessionStorage.setItem('nomeFornitore', data.cognome + " " + response.body.data.nome)
              this.$set(this.form, 'telefono', data.telefono)
              sessionStorage.setItem('telefonoFornitore', data.telefono)
              this.$set(this.form, 'mobile', data.mobile)
              this.$set(this.form, 'mail', data.mail)
              sessionStorage.setItem('mailFornitore', data.mail)
              this.$set(this.form, 'birthday', data.birthday)
              this.$set(this.form, 'reparto', data.reparto)
              this.$set(this.form, 'mansione', data.mansione)
              this.$set(this.form, 'preferredLanguage', data.preferredLanguage)
              this.$set(this.form, 'pIva', data.partitaiva)
              this.$set(this.form, 'ragSoc', data.ragSoc)

              this.$set(this, 'ifMailValdiate', data.ifValidate)

              let arrayInviteApps = []
              data.inviteApps.forEach((item) => {
                let obj = {
                  key: item.codiApp,
                  label: item.descApp,
                  disabled: false
                }
                arrayInviteApps.push(obj)
              })
              this.$set(this, 'appsRichiedibili', arrayInviteApps)
              this.$set(this, 'appsRichieste', [])
              data.userApps.forEach((appRichiesta) => {
                this.appsRichieste.push(appRichiesta.codiApp)
                this.appsRichiedibili.forEach((appRichiedibile) => {
                  if (appRichiesta.codiApp === appRichiedibile.key) {
                    appRichiedibile.disabled = true
                  }
                })
              })
            }
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../assets/less/general.less";

  .modalAmministrazione {
    .el-dialog__header {
      padding: 3px 0 0 0;
      border-bottom: 0;
    }
    .el-table {
      margin-top: 10px;
      margin-bottom: 20px;
      .el-select {
        .el-input__inner {
          border: 1px solid #e7e7e7 !important;
          padding-left: 5px;
        }
      }
      .el-input {
        .el-input__inner {
          border: 1px solid #e7e7e7 !important;
          padding-left: 5px;
        }
      }
    }
  }

  .modalProfilo {
    &.el-dialog__wrapper {
      .el-dialog {
        margin-top: 80px !important;
        .el-dialog__header {
          border-bottom: 0;
        }
        .el-dialog__body {
          .el-tabs {
            .el-tabs__header {
              margin-bottom: 30px;
              .el-tabs__item {
                width: 33.33%;
              }
            }
            .el-tabs__content {
              .form-profilo {
                margin-bottom: 20px;
                .modifica {
                  margin-bottom: 20px !important;
                  .el-switch {
                    margin-left: 20px;
                    height: 25px;
                  }
                }
                .row-custom {
                  margin-bottom: 2px;
                  .profilo-label {
                    height: 32px;
                    line-height: 32px;
                    .set-font(@size: 12px; @color: @greenRiva; @family: 'os-semibold');
                    text-transform: uppercase;
                    letter-spacing: 1px;
                  }
                  .profilo-value {
                    height: 25px;
                    line-height: 25px;
                    .dt-picker-profilo {
                      .el-input__inner {
                        padding-left: 30px !important;
                      }
                    }
                    .error {
                      .el-input__inner {
                        border: 1px solid red !important;
                        color: @grayMedium;
                        height: 32px;
                      }
                    }
                    .el-input {
                      &.is-disabled {
                        .el-input__inner {
                          border: none;
                          color: @grayMedium;
                        }
                      }
                      .el-input__inner {
                        border: none;
                        border-bottom: 1px solid #dcdfe6;
                        color: @grayMedium;
                        height: 32px;
                      }
                      .el-input__inner:focus {
                        border: none !important;
                        border-bottom: 1px solid #dcdfe6 !important;
                      }
                      .el-input__suffix {
                        .el-input__icon {
                          width: 17px;
                        }
                      }
                    }
                    .el-select {
                      .el-input {
                        &.is-disabled {
                          .el-input__inner {
                            border-bottom: none !important;
                            background-color: #f5f7fa;
                          }
                        }
                        .el-input__inner {
                          border: none;
                          border-bottom: 1px solid #dcdfe6;
                          height: 32px !important;
                        }
                      }
                    }
                  }
                }
              }
              .psw-elemento {
                margin-bottom: 10px;
                &.text {
                  .set-font(@size: 13px; @color: #666; @family: 'os-regular');
                  padding: 0 15px;
                }
                .psw-label {
                  .set-font(@size: 12px; @color: @greenRiva; @family: 'os-semibold');
                  text-transform: uppercase;
                  letter-spacing: 1px;
                  height: 25px;
                  line-height: 25px;
                }
                .el-input {
                  .el-input__inner {
                    height: 25px;
                    line-height: 25px;
                    border-bottom: 1px solid #e7e7e7;
                  }
                  .el-input__inner:focus {
                    border: none;
                    border-bottom: 1px solid #dcdfe6 !important;
                  }
                }
              }
              .el-transfer {
                margin: 20px 0px;
                .el-transfer-panel {
                  width: 45%;
                  border-radius: 0px;
                  .el-transfer-panel__empty {
                    display: none;
                  }
                  .el-transfer-panel__header {
                   // background-color: @grayLight;

                    .el-checkbox {
                      .el-checkbox__label {
                       .set-font(@family: 'os-semibold';@color: @greenRiva; @size:15px);
                        span {
                          .set-font(@family: 'os-semibold';@color: @greenRiva; @size:15px);
                        }
                      }
                      .el-checkbox__input {
                        .el-checkbox__inner {
                          border: 0px;
                          border-radius: 0px;
                          background-color: @white;
                        }
                        .el-checkbox__inner::after {
                          height: 7px;
                          width: 2px;
                          left: 5px;
                          border-right: 2px solid @greenRiva;
                          border-bottom: 2px solid @greenRiva;
                        }
                      }
                    }
                  }
                  .el-transfer-panel__body {
                    .el-transfer-panel__item {
                      .el-checkbox__input {
                        .el-checkbox__inner {
                          border: 1px solid @greenRiva;
                          border-radius: 0px;
                          background-color: @white;
                        }
                        &.is-checked {
                          .el-checkbox__inner::after {
                            height: 7px;
                            width: 2px;
                            left: 4px;
                            border-right: 2px solid @greenRiva;
                            border-bottom: 2px solid @greenRiva;
                          }
                        }
                      }
                      .el-checkbox__input.is-checked+.el-checkbox__label {
                        color: @greenRiva;
                      }
                      .el-checkbox__label:hover {
                        color: @greenRiva;
                      }
                    }
                  }
                }
                .el-transfer__buttons {
                  width: 10%;
                  padding: 0px;
                  .el-transfer__button {
                    margin: auto !important;
                    margin-bottom: 10px !important;
                    background-color: @greenRiva;
                    &.is-disabled {
                      background-color: #e7e7e7;
                      span {
                        color: @white;
                      }
                    }
                  }
                }
              }
            }
          }
          .footer {
            margin-top: 15px;
            .el-button {
              float: right;
            }
          }
        }
      }
    }
  }

  .modalUtenti {
    .el-dialog__header {
      padding: 3px 0 0 0;
      border-bottom: 0;
    }
    .el-table {
      margin-top: 10px;
      margin-bottom: 20px;
      width: 100%;
      .el-table__header {
        margin-bottom: 2px;
      }
      .el-table__body {
        td {
          border-bottom: 0;
        }
        .cell {
          .el-switch__core {
            height: 12px;
            width: 25px !important;
          }
          .el-switch__core:after {
            background-color: #e7e7e7;
            height: 14px;
            width: 14px;
            top: -2px;
            left: -2px;
          }
          .el-switch.is-checked {
            .el-switch__core::after {
              margin-left: -12px;
              left: 100%;
            }
          }
          .el-input {
            width: 88%;
          }
          .icon-modifica {
            color: @greenRiva;
            margin-left: 3px;
          }
        }
      }
    }
  }

  .header {
    height: 56px;
    background-color: #ffffff;
    box-shadow: 1px 2px 5px #C0C0C0;
    overflow: hidden;
    z-index: 10;
    .logo-header {
      img {
        height: 64px;
        width: 64px;
        margin-top: -4px;
        margin-left: -5px;
      }
    }
    .header-margin-top {
      margin-top: 15px;
    }
    .utente {
      .user-top {
        text-align: right;
        line-height: 24px;
        .set-font(@color: #454848; @size: 13px; @weight: 800);
        padding-top: 4px;
        height: 25px;
      }
      .user-bottom {
        text-align: right;
        line-height: 24px;
        .set-font(@color: @greenRiva; @size: 13px; @weight: 600);
        text-transform: uppercase;
        .admin {
          .set-font(@color: red; @size: 13px; @weight: 600);
        }
      }
    }
    .show-messaggi {
      text-align: right;
      .badge-bacheca {
        .badge-nuovi {
          .el-badge__content.is-fixed {
            top: 15px;
            left: -35px;
          }
          .el-badge__content {
            height: 22px;
            width: 22px;
            border-radius: 50%;
            line-height: 17px;
            padding: 1px 0px;
            text-align: center;
            .set-font(@size: 11px; @color: @white);
            background-color: red;
          }
        }
        .el-badge__content.is-fixed {
          top: 15px;
          left: -5px;
        }
        .el-badge__content {
          height: 22px;
          width: 22px;
          border-radius: 50%;
          line-height: 17px;
          padding: 1px 0px;
          text-align: center;
          .set-font(@size: 11px; @color: @white);
          background-color: @oroRiva;
        }
      }
    }
    .pointer:hover {
      cursor: pointer;
    }
    .button-primary:hover {
      background-color: #ffffff !important;
      color: #007c74 !important;
    }
    .riv-phone-c0 {
      fill: #606266;
    }
    .riv-world-c0 {
      fill: #606266;
    }
    .riv-user-c0 {
      fill: #606266;
    }
    .riv-contacts-c0 {
      fill: #606266;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderApp.vue